function getConfigCompoment () { return 'ExtConfigCompoment' }
function getStandardAttributes () { return null }

export default {
  hasExecutions: () => true,
  getConfigCompoment,
  getStandardAttributes
}
